var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 464,
    height: 312,
    viewBox: "0 0 464 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Feature-6-svg-a",
    x: 240,
    y: 0,
    width: 224,
    height: 312,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Feature-6-svg-c",
    x: 0,
    y: 0,
    width: 224,
    height: 312,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(240)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -252, -10)",
    filter: "url(#Feature-6-svg-a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 288,
    rx: 8,
    transform: "translate(252 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 104) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 45,
    rx: 6,
    transform: "translate(155 104) rotate(90)",
    fill: "#de4b35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 168) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 92,
    rx: 6,
    transform: "translate(140 168) rotate(90)",
    fill: "#de4b35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 152,
    rx: 6.5,
    transform: "translate(176 200) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 137) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 92,
    rx: 6,
    transform: "translate(116 232) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(70 25)",
    fill: "#de4b35",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14.911,
    y: 13,
    xmlSpace: "preserve"
  }, "Date  20.02.2021"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -10)",
    filter: "url(#Feature-6-svg-c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 288,
    rx: 8,
    transform: "translate(12 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 104) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 168) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 152,
    rx: 6.5,
    transform: "translate(176 200) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 137) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 92,
    rx: 6,
    transform: "translate(116 232) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(70 25)",
    fill: "#4f4e74",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14.911,
    y: 13,
    xmlSpace: "preserve"
  }, "Date  10.01.2020")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature6);
export default __webpack_public_path__ + "static/media/feature6.5b524b6b220bdf9fed44cf04d937d50a.svg";
export { ForwardRef as ReactComponent };